<template>
  <!-- パスのis_validフラグが立っている&カウントダウンが0ならグレーアウト -->
  <div class="list-item__ticket" :class="{ used: countDown === '00:00:00:00' }">
    <!-- パス名 -->
    <div class="index-ticket-left">
      <span class="list-item__title passsheet_title">
        {{ displayPassName(props.bookGroup, pass) }}
      </span>
    </div>

    <!-- 右部ステイタス表示 -->
    <!-- book.is_expiredフラグが立っていたら非表示 -->
    <PUseStatusButton
      v-if="!props.isExpiredBook"
      :bookGroup="props.bookGroup"
      :pass="pass"
      :isAvailablePeriod="props.isAvailablePeriod"
      :countDown="countDown"
    />
    <!-- 右部ステイタス表示 -->

    <div class="ticket-index-square left-square"></div>
    <div class="ticket-index-square right-square"></div>
  </div>
</template>
<script>
import { onMounted, computed, watchEffect, ref } from "vue";

import API from "@/API";
import myTicketsCommonService from "@/services/common/myTickets";
import passService from "@/services/pass";

export default {
  name: "ItemIndexPassTile",
  props: {
    bookGroup: {
      type: Object,
      required: true,
    },
    pass: {
      type: Object,
      required: true,
    },
    isAvailablePeriod: {
      type: Boolean,
      required: true,
    },
    isExpiredBook: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    const countDown = ref(null);
    const pass = ref({}); // QR改札チケットは再取得するので、扱いを統一するため、pass定義
    const interval = ref(null);

    const updateCountDown = () => {
      // pass.user_limited_atが入ってから=pass有効化後に、countDownに値が入る
      if (pass.value.user_limited_at) {
        countDown.value = myTicketsCommonService.getCountDown(
          pass.value.user_limited_at
        );
      }
    };

    onMounted(async () => {
      // QR改札チケットで使用中の場合、チケットステータス同期のため、pass情報を再取得する
      // ケースによって以下の通り、bookとpassのis_expiredが異なるので、どちらもfalseの場合のみ使用中とみなす
      // 終了ボタンで終了した場合、book.is_expired: true, pass.is_expired: false
      // 改札出場の場合、book.is_expired: false, pass.is_expired: true
      if (
        !props.isExpiredBook &&
        !props.pass.is_expired &&
        props.pass.is_valid &&
        passService.checkIsQrTicketGate(props.pass)
      ) {
        pass.value = await API.getPass(props.pass.id);
      } else {
        // propsのpassをそのまま使う
        pass.value = props.pass;
      }
      updateCountDown();
      interval.value = setInterval(() => updateCountDown(), 1 * 1000);
    });

    watchEffect(() => {
      // passのis_expiredが立っている場合、カウントダウン0で使用済みとして扱う(QR改札出場後対応)
      if (pass.value.is_expired) {
        countDown.value = "00:00:00:00";
      }

      // bookが期限切れ or カウントダウン0の場合は、以降のステータスの変動はないのでカウントダウン計算を止める
      if (props.isExpiredBook || countDown.value == "00:00:00:00") {
        clearInterval(interval.value);
      }
    });

    return {
      countDown,
      pass,
      props,
    };
  },
};
</script>
<style lang="scss" scoped>
.used {
  background: #f0f0f0;
}

.list-item__ticket {
  height: 51px;
  position: relative;
  border-top: 1px dashed #d7d7d7;
}

.list-item__ticket .used {
  height: 12vw;
  border-top: 1px dashed #f9f9f9;
}

.list-item__title {
  font-size: 15px;
  position: absolute;
  top: 25%;
  overflow: hidden;
  font-weight: bold;
}

.index-ticket-left {
  float: left;
  width: 77%;
  font-size: 3vw;
  overflow: hidden;
  padding: 0 2%;
  position: relative;
  top: 50%;
  transform: translate(0%, -50%);
  -webkit-transform: translate(0%, -50%);
  -ms-transform: translate(0%, -50%);
}

.passsheet_title {
  position: unset;
  display: block;
  margin: 4vw;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 500;
}

.ticket-index-square {
  position: relative;
  width: 16px;
  height: 16px;
  background-color: #f9f9f9;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  z-index: 0;
  border: 1px solid #e9e9e9;
  border-radius: 8px;
}

.left-square {
  margin-left: -5.5px;
  top: -10px;
  border-bottom: none;
  border-left: none;
}

.right-square {
  margin-left: calc(100% - 12px);
  top: -26px;
  border-top: none;
  border-right: none;
}

@media screen and (min-width: 421px) {
  .list-item__ticket {
    height: 12vw;
  }

  .list-item__title {
    font-size: 4vw;
  }
}
</style>
